import { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import {useParams } from 'react-router-dom'
import { Dropdown } from 'primereact/dropdown';
import { useFormik } from 'formik'
import axios from 'axios' 
import { comparer } from '../../utils/comparer'
import { Rating } from 'primereact/rating'
import * as Yup from 'yup';
import { errorCss, getValue } from '../Utils/formik-util';
import { MatchageConstanteFormComponent, MatchageConstanteGenerateYup } from '../ConstantesConfig/MatchageConstantes'
import { useAuthUser } from '../../auth'
import { AOMatchedResultsComponent } from './AOMatched'
import { useToast } from "../../toastHook";
import { Modal } from 'bootstrap'
import { extractNumberFromInput } from "../../utils/inputUtils"
import { ConfirmModalComponent } from '../Utils/ConfirmModal';
import { urlDecodeObject } from '../../utils/url-encode-object'
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useDrop, useDrag, DndProvider } from 'react-dnd';

export const InfoAndCacheRefreshComponent = ({ children }) => {


    const { checkRole } = useAuthUser();
    const { display } = useToast();

    const refreshCacheCall = () => {
        axios.get('/api/aoutility/clearcache').then(response => {
            if (response.status === 200) {
                display({
                    titre: 'cache engine rafraîchit',
                    text: `le  cache de l'engine a été rafraîchit'`,
                    severity: 'success'
                });
            }
            else {
                display({
                    titre: 'cache engine non rafraîchit',
                    text: `le  cache de l'engine n'a pas été rafraîchit, une erreur s'est produite veuillez réessayer`,
                    severity: 'danger'
                });
            }
        })
    }
;
    if (!checkRole('Pocahontas_CacheEngine')) {
        return <></>
    }

    return <div className="alert alert-info" >{children}<br />
        <button onClick={refreshCacheCall} className="btn btn-outline-primary">rafraîchir le cache engine</button>
    </div>
}

const CompetenceComponent = ({ competence,origin, isCompetenceSuggeree, removeCompetence, setNiveau}) => {
    const [{ isDragging }, dragRef] = useDrag(() => ({
        type: "competence",
        item: { competence, origin },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    }))
    const opacity = isDragging ? 0.6 : 1

    if (isCompetenceSuggeree) {
        return <div ref={dragRef} style={{ opacity }} className="col-2 alert alert-primary" >
            <div className="d-flex flex-row justify-content-between"><span className="justify-content" >{competence.nom}</span></div> <Rating value={competence.niveau} cancel={false} />
        </div>
    }

    return (
        <div ref={dragRef} style={{ opacity }} className="col-2 alert alert-secondary" >
            <div className="d-flex flex-row justify-content-between"><span className="justify-content" >{competence.nom}</span>{removeCompetence ? <i className="pi pi-times-circle text-danger justify-content " onClick={() => removeCompetence(competence.nom)} ></i> : <></>} </div> <Rating value={competence.niveau} cancel={false} onChange={e => { if (setNiveau) { setNiveau(competence.nom, e.value) } }} />
        </div>
    )
}

export const ChooseCompentenceComponent = ({ competences, setCompetence, competencesBloquantes, removeCompetence, displayCompetencesBloquantes, switchCompetence , avalaibleCompetences, addCompetenceSuggeree }) => {

    const [pleaseDealWithDraggedCompetence, setPleaseDealWithDraggedCompetence] = useState();


    const addCompetence = e => {
        let competence = e.target.value

        if (competences.find(x => x.nom === competence)) {
            return;
        }

        setCompetence({  
            nom: competence,
            niveau : 1
        })
    }

    const setNiveau = (competence, stars) => {
        setCompetence({
            nom: competence,
            niveau : stars
        })
    } 

    const [{ }, dropRef] = useDrop(() => ({
        accept: "competence",
        drop: item => setPleaseDealWithDraggedCompetence({  competence: item.competence, origin: item.origin } )
    }))

    if (pleaseDealWithDraggedCompetence) {

        if (pleaseDealWithDraggedCompetence.origin === "competence" || pleaseDealWithDraggedCompetence.origin === "competenceBloquante") {
            switchCompetence(pleaseDealWithDraggedCompetence.competence.nom);
        }

        if (pleaseDealWithDraggedCompetence.origin === "competenceSuggeree") {
            addCompetenceSuggeree(pleaseDealWithDraggedCompetence.competence, displayCompetencesBloquantes);
        }

        setPleaseDealWithDraggedCompetence(undefined);
    }

    let displayCompetences = <></>

    if (competences) {
        displayCompetences = competences.filter(x => {
            const isCompetenceBloquante = competencesBloquantes.find(y => y === x.nom) != null;

            if (displayCompetencesBloquantes && isCompetenceBloquante) {
                return true;
            }

            if (!displayCompetencesBloquantes && !isCompetenceBloquante) {
                return true;
            }

            return false;
        }).map(
            x => {
                const isCompetenceBloquante = competencesBloquantes.find(y => y === x.nom) != null;

                return <CompetenceComponent key={x.nom} competence={x} origin={isCompetenceBloquante ? "competenceBloquante" : "competence"} removeCompetence={removeCompetence} setNiveau={setNiveau} />
            }
        );
    }



    return <div ref={dropRef} >
        <div className="card mb-4" >
            <div className="card-header">
                Compétences { displayCompetencesBloquantes ? "Obligatoires" : "" }
            </div>
            <div className="card-body">
                <Dropdown onChange={addCompetence}
                    name="competence" options={avalaibleCompetences} optionLabel="value" optionValue="value" placeholder="Sélectionner une compétence" filter />
                <div className="d-flex flex-row flex-wrap gap-4 mt-4">
                    { displayCompetences }
                </div>
            </div>
        </div>
    </div>
}

export const DisplayCompetenceSuggerees = ({ competencesSuggerees, competences }) => {

    const [{ }, dropRef] = useDrop(() => ({
        accept: "competence"
    }))

    if (!competencesSuggerees || competencesSuggerees.length === 0) {
        return <></>
    }

    return <div ref={dropRef} >
        <div className="card mb-4" >
            <div className="card-header">
                Compétences suggérées
            </div>
            <div className="card-body d-flex flex-row flex-wrap gap-4">
                {competencesSuggerees.filter(x => !competences.find(y => y.nom === x.nom)).map(x => <CompetenceComponent key={x.nom} competence={x} origin={ "competenceSuggeree" } isCompetenceSuggeree={ true } />) }
            </div>
        </div>
    </div>
}

const ActiviteExperienceInputComponent = ({ experience, setExperience, setGlobalError }) => {
    const [type, setType] = useState('');
    const [typeError, setTypeError] = useState('veuillez spécifier un type');
    const [experienceErrorMessage1, setExperienceErrorMessage1] = useState('');
    const [experienceErrorMessage2, setExperienceErrorMessage2] = useState('');
    const [globalExperienceErrorMessage, setGlobalExperienceErrorMessage] = useState('');

    const setErrorMessageForExperienceAndReturnIfValid = (experience, setterErrorMessage) => {
        if (!experience && experience !== 0) {
            setterErrorMessage("l'expérience est requise");
            setGlobalError("l'expérience est requise");
            return false;
        }

        if (typeof experience !== "number") {
            setterErrorMessage("l'expérience doit être un nombre");
            setGlobalError("l'expérience doit être un nombre");
            return false;
        }

        if (experience < 0) {
            setterErrorMessage("l'expérience doit être positive");
            setGlobalError("l'expérience doit être positive");
            return false;
        }

        return true;
    }

    useLayoutEffect(() => {

        if (!type) {
            setGlobalError(typeError);
            return;
        }
        switch (type) {
            case 'unknow':
                setGlobalError('');
                break;
            case 'year':

                if (!setErrorMessageForExperienceAndReturnIfValid(experience, setExperienceErrorMessage1)) {
                    return;
                }

                setExperienceErrorMessage1("");
                setGlobalError('');

                return;

            case 'year+':

                if (!experience || typeof experience !== "object" || experience.length !== 2 || (!experience[0] && experience[0] !== 0 )) {
                    setExperienceErrorMessage1("l'expérience est requise");
                    setGlobalError("l'expérience est requise");
                    return;
                }

                if (!setErrorMessageForExperienceAndReturnIfValid(experience[0], setExperienceErrorMessage1)) {
                    return;
                }

                setExperienceErrorMessage1("");
                setGlobalError('');

                return;

            case 'array':

                setGlobalExperienceErrorMessage('');
                setExperienceErrorMessage1("");
                setExperienceErrorMessage2("");

                if (!experience || typeof experience !== "object" || experience.length !== 2 || (!experience[0]  && experience[0] !== 0  )) {
                    setExperienceErrorMessage1("l'expérience est requise");
                    setExperienceErrorMessage2("l'expérience est requise");
                    setGlobalError("l'expérience est requise");
                    return;
                }

                if (!setErrorMessageForExperienceAndReturnIfValid(experience[0], setExperienceErrorMessage1)) {
                    return;
                }

                if (!setErrorMessageForExperienceAndReturnIfValid(experience[1], setExperienceErrorMessage2)) {
                    return;
                }

                if (experience[0] >= experience[1]) {
                    setGlobalExperienceErrorMessage("l'expérience de gauche doit être strictement supérieur à l'expérience de droite")
                    setGlobalError("l'expérience de gauche doit être strictement supérieur à l'expérience de droite")
                    return;
                }

                setExperienceErrorMessage1("");
                setExperienceErrorMessage2("");
                setGlobalError('');

                return;
            default:
                throw Error("un bug !");
        }

    }, [type, experience]);

    useEffect(() => {

        if (!experience) {
            return;
        }

        if (typeof experience === 'number') {

            if (experience === -1) {
                setType('unknow');
                setTypeError('');
            }
            else {
                setType('year');
                setTypeError('');
            }

            return;
        }


        if (typeof experience === "object" && experience.length === 2) {

            if (experience[1] === '+') {
                setType("year+");
                setTypeError('');
            }
            else {
                setType("array");
                setTypeError('');
            }

        }

    }, [experience]);

    const handleExperienceYearChange = e => {
        setExperience(extractNumberFromInput(e.target));
    }

    const handleExperienceYearPlusChange = e => {
        var experience = extractNumberFromInput(e.target);

        setExperience([experience, '+']);
    }

    const handleExperienceArray = (e, i) => {
        var experienceValue = extractNumberFromInput(e.target);

        if (!experience) {
            var newExperience = Array(2);
        }
        else {
            var newExperience = experience.map(x => x);
        }

        newExperience[i] = experienceValue;

        setExperience(newExperience);
    }

    const getExperienceFromArray = i  => {
        if (experience && typeof (experience) === 'object' && experience.length === 2) {
            return experience[i];
        }

        return '';
    }

    var specificTypeHtml = <></>

    switch (type) {
        case 'year':
            specificTypeHtml = <><div className="col-auto align-middle">
                <label htmlFor="experience" className="col-form-label">Expérience</label>
            </div>
                <div className="col-auto col">
                    <input id="experience" type="number" step="1" className={`form-control ${errorCss(experienceErrorMessage1)}`} value={experience} onChange={handleExperienceYearChange} />
                    {experienceErrorMessage1 ? (
                        <div className="text-danger">{experienceErrorMessage1}</div>
                    ) : (<></>)}
                </div></>
            break;
        case 'year+':
            specificTypeHtml = <><div className="col-auto align-middle">
                <label htmlFor="experience" className="col-form-label">Expérience (supérieur à )</label>
            </div>
                <div className="col-auto col">
                    <input id="experience" type="number" step="1" className={`form-control ${errorCss(experienceErrorMessage1)}`} value={getExperienceFromArray(0)} onChange={handleExperienceYearPlusChange} />
                    {experienceErrorMessage1 ? (
                        <div className="text-danger">{experienceErrorMessage1}</div>
                    ) : (<></>)}
                </div></>
            break;
        case 'array':
            specificTypeHtml = <>
                {globalExperienceErrorMessage ? (<div className="text-danger">{ globalExperienceErrorMessage }</div>) : (<></>) }
                <div className="col-auto align-middle">
                <label htmlFor="experience" className="col-form-label">De</label>
            </div>
                <div className="col-auto col">
                    <input id="experience" type="number" step="1" className={`form-control ${errorCss(experienceErrorMessage1)}`} value={getExperienceFromArray(0)} onChange={ e => handleExperienceArray(e,0)} />
                    {experienceErrorMessage1 ? (
                        <div className="text-danger">{experienceErrorMessage1}</div>
                    ) : (<></>)}
                </div>
                <div className="col-auto align-middle">
                    <label htmlFor="experience" className="col-form-label">à</label>
                </div>
                <div className="col-auto col">
                    <input id="experience" type="number" step="1" className={`form-control ${errorCss(experienceErrorMessage2)}`} value={getExperienceFromArray(1)} onChange={e => handleExperienceArray(e, 1)} />
                    {experienceErrorMessage2 ? (
                        <div className="text-danger">{experienceErrorMessage2}</div>
                    ) : (<></>)}
                </div>            </>
            break;
        default:
            break;
    }

    const changeType = e => {

        var type = e.target.value;

        if (type) {
            setTypeError('');
        }

        setType(type);

        switch (type) {
            case "unknow":
                setExperience(-1);
                break;
            default:
                setExperience(undefined);
        }

    }


    return <div className="row g-3">
        <div className="col-auto align-middle">
            <label htmlFor="type" className="col-form-label">Type</label>
        </div>
        <div className="col-auto col">
            <select id="type" className="form-select" value={ type } onChange={e => changeType(e)} >
                <option value="" hidden>sélectionnez</option>
                <option value="unknow">inconnue</option>
                <option value="year">année</option>
                <option value="array">interval d'année</option>
                <option value="year+">année et plus</option>
            </select>
            {typeError? (
                <div className="text-danger">{typeError}</div>
            ) : (<></>)}
        </div>
        {specificTypeHtml }
    </div>
}

const ChooseActivitesComponent = ({ activites, selectedActivites, setSelectedActivites, setIsValid }) => {

    const [errorsActivites, setErrorsActivites] = useState([]);
    const [globalError, setGlobalError] = useState("");
    const [errorCount, setErrorCount] = useState(1);

    useEffect(() => {

        const errors = Array.from({ length: selectedActivites.length }, () => Array(2).fill(''));

        for (var index = 0; index < selectedActivites.length; index++) {

            if (!selectedActivites[index].name) {
                errors[index][0]  = "l'activité doit être sélectionnée"
            }

            if (index < errorsActivites.length) {
                errors[index][1] = errorsActivites[index][1];
            }
            else {
                // tableau non créé lorsque l'on crée une nouvelle activité et que l'on met le error avec le handle error

                // erreur du composant d'expérience pas encore chargé
                setErrorCount(errorCount + 1);
            }
        }

        var gError = '';

        if (selectedActivites.length === 0) {
            gError = "vous devez mettre au moins une activité";
        }
        else {
            setSelectedActivites = new Set(selectedActivites.map(x => x.name));
            if (setSelectedActivites.size !== selectedActivites.length) {
                gError = "vous avez des activités en doublons, veuillez supprimer les doublons";
            }
        }

        var isValid = !gError && !errors.find(x => x[0] || x[1]);
        setIsValid(isValid);

        setErrorsActivites(errors);
        setGlobalError(gError);

    }, [selectedActivites, errorCount])

    const handleChange = (e, i) => {
        var name = e.target.id

        var newSelectedActivites = selectedActivites.map(x => { return { ...x }
});

        if (name.startsWith('activite')) {
            newSelectedActivites[i].name = e.target.value;
        }

        setSelectedActivites(newSelectedActivites);
    }

    const handleExperienceChange = (experience, i) => {
        var newSelectedActivites = selectedActivites.map(x => {
            return { ...x }
        });

        newSelectedActivites[i].experience = experience;

        setSelectedActivites(newSelectedActivites);
    }

    const setErrorExperience = (error, i) => {

        if (errorsActivites.length <= i) {

            var errors = new Array(i + 1);
            for (var index = 0; index < errorsActivites.length ; index++) {
                errors[index] = [...errorsActivites[index]];
            }
            for (var index = errorsActivites.length; index <= i; ++index) {
                errors[index] = ['', ''];
            }

            errors[i][1] = error;
        }
        else {
            var errors = errorsActivites.map(x => [...x]);
            errors[i][1] = error;
        }

        setErrorsActivites(errors);
        setErrorCount(errorCount + 1);
    }

    const getErrorCssActivite = (i, i2) => {
        if (errorsActivites.length <=  i) {
            return "";
        }

        return errorsActivites[i][i2];
    }

    const add = () => {
        setSelectedActivites([...selectedActivites, { name: '', experience: 0 }]);
    }

    const remove = index => {
        setSelectedActivites(selectedActivites.filter((x,i) => i !== index ))
    }

    return <div>
        {globalError ? (
            <div className="text-danger mb-3">{globalError}</div>
        ) : (<></>)}
        <div><button type="button" className="ms-2 btn btn-outline-success input-group-text" onClick={add} ><i className="pi pi-plus"></i> </button></div>
        <div>
            {selectedActivites.map((a, i) => <div key={"activite_" + i} className="col-12 alert alert-secondary d-flex flex-row"> 
            <div className="col-11">
            <div className="mb-3">
                <label htmlFor={"activite_" + i} className="form-label">Activité</label>
                <select className={`form-select ${errorCss(getErrorCssActivite(i,0))}`} aria-label={"activite_" + i} id={"activite_" + i}  placeholder="activité" onChange={e => handleChange(e,i)} value={a.name}  >
                            <option value="" hidden>selectionnez</option>
                            {activites.map(x => <option key={x.activite}>{x.activite}</option>)}
                </select>
                {errorCss(getErrorCssActivite(i, 0)) ? (
                    <div className="invalid-feedback">{getErrorCssActivite(i, 0)}</div>
                ) : (<></>)}
            </div>
            <div className="mb-3">
                        <label htmlFor={"experience_" + i} className="form-label">Expérience{getErrorCssActivite(i, 1) ? (
                                <span className="text-danger">*</span>
                            ) : (<></>)}</label>
                            </div>
                    <ActiviteExperienceInputComponent experience={a.experience} setExperience={xp => handleExperienceChange(xp, i)} setGlobalError={ error => setErrorExperience(error, i) } />
            </div>
                <div className="col-1 text-end" ><i className="pi pi-times-circle text-danger justify-content " onClick={() => remove(i)} ></i></div>
        </div>)}
        </div>
    </div>
}

export const AOOnDemandQueryComponent = ({ onLoad, configQuery, isValid })  => {

    const [queries, setQueries] = useState([]);
    const [loadQuery, setLoadQuery] = useState();
    const [count, setCount] = useState(0);
    const [title, setTitle] = useState("");
    const [idToWork, setIdToWork] = useState();
    const [justSavedTitle, setJustSavedTitle] = useState(undefined);
    const titleInsertRef = useRef();
    const titleUpdateRef = useRef();
    const { display } = useToast();
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [openUpdateModal, setOpenUpdateModal] = useState(false);

    useEffect(() => {
        axios.get('/api/ondemandquery/queries').then(
            response => {
                if (response.data) {
                    response.data.sort((x, y) => comparer(x.titre, y.titre));
                    setQueries(response.data);

                    if (justSavedTitle) {
                        const query = response.data.find(x => x.titre === justSavedTitle)

                        if (query) {
                            setLoadQuery(query);
                        }

                        setJustSavedTitle(undefined);
                    }
                }
            });
    }, [count])

    const pleaseSaveConfig = () => {

        if (!isValid) {
            return;
        }

        setTitle("");
        const modal = Modal.getOrCreateInstance(titleInsertRef.current);
        modal.show();
    }

    const saveConfig = () => {

        if (!title) {
            return;
        }

        axios.post('/api/ondemandquery/insert?titre=' + encodeURIComponent(title), configQuery).then(
            response => {

                if (response.status === 200) {
                    display({
                        titre: 'template sauvée',
                        text: `La sauvegarde du template a eu lieu sous le titre ${title}`,
                        severity: 'success'
                    });

                    setJustSavedTitle(title);
                    setCount(count + 1);
                }
                else {
                    display({
                        titre: 'erreur de sauvegarde du template',
                        text: "La sauvegarde du template n'a pas pus avoir lieu",
                        severity: 'danger'
                    });
                }
            });
    }

    const pleaseUpdateTitre = (id, e) => {

        e.stopPropagation();
        setTitle("");
        setIdToWork(id);
        const modal = Modal.getOrCreateInstance(titleUpdateRef.current);
        modal.show();
    }

    const updateTitre = () => {

        if (!title) {
            return;
        }

        axios.get('/api/ondemandquery/update-titre?id='+ idToWork + '&titre=' + encodeURIComponent(title)).then(
            response => {

                if (response.status === 200) {
                    display({
                        titre: 'titre mis à jour',
                        text: `le nouveau titre ${title} a été mis à jour`,
                        severity: 'success'
                    });

                    if (loadQuery.id === idToWork) {
                        setLoadQuery({ ...loadQuery, titre: title });
                    }

                    setCount(count + 1);
                }
                else {
                    display({
                        titre: 'titre non mis à jour',
                        text: "La mise à jour du titre n'a pas pu avoir lieue",
                        severity: 'danger'
                    });
                }
            });
    }

    const load = value => {

        if (!value) {
            return;
        }

        setLoadQuery(value);

        axios.get('/api/ondemandquery/query?id=' + value.id).then(
            response => {
                if (response.data) {
                    onLoad(response.data);
                }
            });

    }

    const pleaseDelete = (id, titre, e) => {
        e.stopPropagation();

        setTitle(titre);
        setIdToWork(id);

        setOpenDeleteModal(true);
    }

    const deleteTemplate = () => {
        axios.get('/api/ondemandquery/delete?id=' + idToWork ).then(
            response => {

                if (response.status === 200) {
                    display({
                        titre: 'template a été effacé',
                        text: `le template ${title} a été effacé`,
                        severity: 'success'
                    });

                    setCount(count + 1);
                }
                else {
                    display({
                        titre: 'template non effacé',
                        text: `Impossible d'effacer le template ${title}'`,
                        severity: 'danger'
                    });
                }
            });
    }

    const pleaseUpdateTemplate = id => {
        if (!loadQuery || !isValid) {
            return;
        }

        setTitle(loadQuery.titre);
        setIdToWork(loadQuery.id);

        setOpenUpdateModal(true);
    }


    const updateTemplate = () => {

        axios.post('/api/ondemandquery/update?id=' + idToWork, configQuery).then(
            response => {

                if (response.status === 200) {
                    display({
                        titre: 'template mis à jour',
                        text: `le template ${title} a été mis à jour`,
                        severity: 'success'
                    });

                    setCount(count + 1);
                }
                else {
                    display({
                        titre: 'template non mis à jour',
                        text: `Impossible de mettre à jour le template ${title}'`,
                        severity: 'danger'
                    });
                }
            });
    }

    const dropDownValueTemplate = (row) => {
        return <div className="d-flex flex-row gap-3"><span className="flex-grow-1" >{row.titre}</span>
            <i className="bi bi-chat-left-dots text-primary" onClick={e => pleaseUpdateTitre(row.id, e)} />
            <i className="pi pi-ban text-danger" onClick={ e => pleaseDelete(row.id,row.titre, e) } ></i></div>
    } 


    var dropDownLoadQuery = <></>;

    if (queries.length > 0) {
        dropDownLoadQuery = <Dropdown className="flex-grow-1"  value={loadQuery} onChange={(e) => load(e.value)} options={queries} optionLabel="titre" placeholder="Veuillez sélectionner votre template"
            filter itemTemplate={dropDownValueTemplate}  />
    }

    return <div className="alert alert-primary">
        <h5>Chargement / sauvegarde d'un template</h5>
        <div className="d-flex flex-row gap-3">{dropDownLoadQuery} <button className="btn btn-outline-success" onClick={pleaseSaveConfig}>Sauver le template</button>
            {(loadQuery ? <button className="btn btn-outline-success" onClick={pleaseUpdateTemplate}>Mettre à jour le template</button> : <></>)}
        </div>
        <div ref={titleInsertRef} className="modal frontModal" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Sauvegarde du template</h5>
                    </div>
                    <div className="modal-body">
                        <div className="alert alert-info">Veuillez entrer le titre du template</div>

                        <input className="form-control" type="text" value={title} onChange={event => setTitle(event.target.value)} />
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-success" data-bs-dismiss="modal" onClick={saveConfig} >OK</button>
                        <button className="btn btn-danger" data-bs-dismiss="modal">Annuler</button>
                    </div>
                </div>
            </div>
        </div>
        <div ref={titleUpdateRef} className="modal frontModal" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Mise à jour du titre</h5>
                    </div>
                    <div className="modal-body">
                        <div className="alert alert-info">Veuillez entrer le nouveau titre du template</div>

                        <input className="form-control" type="text" value={title} onChange={event => setTitle(event.target.value)} />
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-success" data-bs-dismiss="modal" onClick={updateTitre} >OK</button>
                        <button className="btn btn-danger" data-bs-dismiss="modal">Annuler</button>
                    </div>
                </div>
            </div>
        </div>
        <ConfirmModalComponent titre="suppression de template" message={`Vous aller supprimer le template ${title} êtes-vous sure ?`}
            open={openDeleteModal} setOpen={setOpenDeleteModal} onConfirm={deleteTemplate} />
        <ConfirmModalComponent titre="mise à jour du template" message={`Vous aller mettre à jour le template ${title} êtes-vous sure ?`}
            open={openUpdateModal} setOpen={setOpenUpdateModal} onConfirm={updateTemplate} />
    </div>

}


export const AOOnDemandComponent = () => {

    const { appelOffre } = useParams();
    const { checkRole } = useAuthUser();
    const { display } = useToast();
    const [availableCompetences, setAvalaibleCompetences] = useState([]);
    const [activites, setActivites] = useState([]);
    const [selectedActivitesIsValid, setSelectedActivitesIsValid] = useState(false);
    const [result, setResult] = useState(undefined);

    const canExplain = checkRole('Pocahontas_Explain');
    const canQueryCustom = checkRole('Pocahontas_RunCustom');
    const [hasExplain, setHasExplain] = useState(false);
    const [onlyIntercontrats, setOnlyIntercontrats] = useState(false);
    const [submissionCount, setSubmissionCount] = useState(0);
    const [submitAppelOffre, setSubmitAppelOffre] = useState({});
    const [feedbackKey, setFeedbackKey] = useState('')


    useEffect(() => {
        axios.get('/api/MatchageConfigurationforall/activites').then(
            response => {
                if (response.data) { 
                    const activites = response.data.map(x => {
                        return { activite: x };
                    });
                    activites.sort((x, y) => comparer(x.activite, y.activite));
                    setActivites(activites)
                }
                });
    }, []);

    useEffect(() => {
        axios.get('/api/competences/get').then(response => {
            let tmpCompetences = response.data.map(x => { return { value: x } }
            );
            tmpCompetences.sort((x, y) => comparer(x.value, y.value));
            setAvalaibleCompetences(tmpCompetences)
        })
    }, []);

    useEffect(() => {
        axios.get("/api/MatchageConfigurationforall")
            .then(response => {
                if (response.data) {
                    if (canQueryCustom) {
                        formik.setValues({ ...formik.initialValues, configuration: response.data })
                    }
                    else {
                        setOnlyIntercontrats(response.data.OnlyIntercontrats);
                    }
                }
            })
    }, []);

    useEffect(() => {
        setFeedbackKey('');
    }, [submissionCount]);

    var validationSchema = undefined;
    if (canQueryCustom) {
        validationSchema = Yup.object().shape({
            configuration: MatchageConstanteGenerateYup()
        });
    }


    const initialAppelOffre = useMemo(() => {

        if (appelOffre) {
            try {
                return urlDecodeObject(appelOffre);
            }
            catch
            {
                console.log("impossible de deserializer l'appel d'offre");
            }
        }

        return {
            activites: [],
            conditionForActivite: "AND",
            competencesBloquantes: [],
            competences: []
        };

    });

    const formik = useFormik({
        initialValues: { appelOffre:  initialAppelOffre,
            configuration: {

            }
        },
        validationSchema  : validationSchema,
        onSubmit: values => {

            if (!selectedActivitesIsValid) {
                return;
            }

            setSubmissionCount(submissionCount + 1);
            setSubmitAppelOffre(formik.values.appelOffre);


            if (!canExplain) {
                formik.setFieldValue('configuration.MustExplain', false);
            }

            setHasExplain(formik.values.configuration.MustExplain);
            axios.post('/api/aoondemand', values).then(response => {
                if (response.data) {
                    setResult(response.data);
                }
            })
        },
        enableReinitialize: true
    });

    const setCompetence = (competence, isCompetenceBloquante) =>  {
        var competences = formik.values.appelOffre.competences;
        var competencesBloquantes = formik.values.appelOffre.competencesBloquantes;

        var isAlreadyBloquante = competencesBloquantes.find(x => x === competence.nom) != null;

        if (!isCompetenceBloquante && isAlreadyBloquante) {
                return;
        }

        competences = competences.filter(y => y.nom !== competence.nom);
        competences = [ ...competences, competence ]
        competences.sort((y, z) => comparer(y.nom, z.nom));

        formik.setFieldValue("appelOffre.competences", competences);

        if ( isCompetenceBloquante && !isAlreadyBloquante ) {
            formik.setFieldValue("appelOffre.competencesBloquantes", [...competencesBloquantes, competence.nom]);
        }
    }

    const switchCompetence = (nomCompetence, isCompetenceBloquante)  => {

        const competences = formik.values.appelOffre.competences;
        const competencesBloquantes = formik.values.appelOffre.competencesBloquantes;

        if (!competences.find(x => x.nom === nomCompetence) )
        {
            return;
        }

        var isAlreadyBloquante = competencesBloquantes.find(x => x === nomCompetence) != null;

        if (isAlreadyBloquante === isCompetenceBloquante) {
            return;
        }

        if (isAlreadyBloquante) {
            formik.setFieldValue("appelOffre.competencesBloquantes", formik.values.appelOffre.competencesBloquantes.filter(x => x !== nomCompetence));
        }
        else {
            formik.setFieldValue("appelOffre.competencesBloquantes", [...competencesBloquantes, nomCompetence]);
        }

        
    }

    const addCompetenceSuggeree = (competence, isCompetenceBloquante) =>
    {
        const competences = formik.values.appelOffre.competences;
        const competencesBloquantes = formik.values.appelOffre.competencesBloquantes;

        if (competences.find(x => x.nom === competence.nom)) {
            return;
        }

        formik.setFieldValue("appelOffre.competences", [...competences, competence]);

        if (isCompetenceBloquante) {
            formik.setFieldValue("appelOffre.competencesBloquantes", [...competencesBloquantes, competence.nom]);
        }
    }

    const removeCompetence = nomCompetence => {
        formik.setFieldValue("appelOffre.competences", formik.values.appelOffre.competences.filter(x => x.nom !== nomCompetence));
        formik.setFieldValue("appelOffre.competencesBloquantes", formik.values.appelOffre.competencesBloquantes.filter(x => x !== nomCompetence));
    }

    const handleChangeConfiguration = e => {
        const name = e.target.name;

        let value = getValue(e.target);

        formik.setFieldValue('configuration.' + name, value);
    }

    const getDetail = index => {
            return axios.get('/api/aoondemand/detail?key=' + result.key + '&row=' + index)
    }

    const setFeedbackWithKey = (key, feedback, onSuccess) => {
        axios.post("/api/feedback/setwithkey?key=" + key, { feedbackScore: feedback.feedbackScore, feedbackMessage: feedback.feedbackMessage, personalInfoId: feedback.personalInfoId })
            .then(response => {
                if (response.status === 200) {
                    display({
                        titre: 'feedback enregistré',
                        text: `feedback enregistré pour  ${feedback.prenom} ${feedback.nom}`,
                        severity: 'success'
                    });

                    onSuccess();
                }
                else {
                    display({
                        titre: 'feedback non entregistré',
                        text: `feedback non enregistré pour  ${feedback.prenom} ${feedback.nom}`,
                        severity: 'danger'
                    });
                }
            });
    }

    const setFeedback = (feedback, onSuccess) => {

        if (feedbackKey) {
            setFeedbackWithKey(feedbackKey, feedback, onSuccess);
        }
        else {
            axios.post("/api/feedback/getkey", { appelOffre: submitAppelOffre, results: result.results.map(x => { return { personalInfoId: x.personalInfoId, score: x.score, additionalInfo: x.additionalInfo } }) })
                .then(response => {
                    if (response.status === 200 && response.data) {
                        setFeedbackKey(response.data);

                        setFeedbackWithKey(response.data, feedback, onSuccess);
                    }
                    else {
                        display({
                            titre: 'feedback non entregistré',
                            text: `feedback non enregistré pour  ${feedback.prenom} ${feedback.nom}`,
                            severity: 'danger'
                        });
                    }
                })
        }
    }

    let results = <></>
    if (result ) {
       results =  <div>
           <AOMatchedResultsComponent matchingResults={result.results} aoParsed={{ value: submitAppelOffre } } hasExplain={hasExplain} getDetail={getDetail} onlyIntercontrats={canQueryCustom ? formik.values?.configuration?.OnlyIntercontrats : onlyIntercontrats} setFeedback={ setFeedback } />
        </div>
    }

    return <div>
        <InfoAndCacheRefreshComponent />
        <AOOnDemandQueryComponent configQuery={formik.values.appelOffre} onLoad={appelOffre => formik.setFieldValue("appelOffre", appelOffre)} isValid={ selectedActivitesIsValid }></AOOnDemandQueryComponent>
        <form onSubmit={formik.handleSubmit}
        >
            <DndProvider backend={HTML5Backend}>
            {canQueryCustom ?
                <div className="card mb-4">
                    <div className="card-header">
                        Configuration du run on demand
                    </div>
                    <div className="card-body">
                        <MatchageConstanteFormComponent values={formik.values.configuration} handleChange={handleChangeConfiguration} errors={formik.errors.configuration} hasExplainAlert={false} hasExplain={canExplain} />
                    </div>
                </div>
                : <></>
            }
            <div className="card mb-4">
                    <div className="card-header d-flex justify-content-between">
                        <span>Activités</span>
                        <select className="form-select" name="appelOffre.conditionForActivite"  value={formik.values.appelOffre.conditionForActivite} onChange={formik.handleChange } style={{ width: "auto" }}>
                            <option value="AND" selected>et</option>
                            <option value="OR">ou</option>
                        </select>
                </div>
                <div className="card-body">
                    <ChooseActivitesComponent activites={activites} selectedActivites={formik.values.appelOffre.activites} setSelectedActivites={a => formik.setFieldValue("appelOffre.activites", a)} setIsValid={ setSelectedActivitesIsValid } />
                </div>
            </div>
                <ChooseCompentenceComponent competences={formik.values.appelOffre.competences} setCompetence={x => setCompetence(x, true)} switchCompetence={x => switchCompetence(x, true)} competencesBloquantes={formik.values.appelOffre.competencesBloquantes} displayCompetencesBloquantes={true} avalaibleCompetences={availableCompetences} removeCompetence={removeCompetence} addCompetenceSuggeree={addCompetenceSuggeree} ></ChooseCompentenceComponent>
                <ChooseCompentenceComponent competences={formik.values.appelOffre.competences} setCompetence={x => setCompetence(x, false)} switchCompetence={x => switchCompetence(x, false)} competencesBloquantes={formik.values.appelOffre.competencesBloquantes} displayCompetencesBloquantes={false} avalaibleCompetences={availableCompetences} removeCompetence={removeCompetence} addCompetenceSuggeree={ addCompetenceSuggeree } ></ChooseCompentenceComponent>
                <DisplayCompetenceSuggerees competences={formik.values.appelOffre.competences} competencesSuggerees={ formik.values.appelOffre.competencesSuggerees } />
                <div className="d-flex flex-row justify-content-center mb-5">
            <button type="submit" className="btn btn-primary" >Lancer le calcul</button>
                </div>
            </DndProvider>
        </form>
        {results}
    </div>
}





